import Text from '../../Text'
import { LABEL_TEXT_COLOR } from '../Label.constants'
import { getLabelColor } from '../Label.utils'

import * as styles from './LabelSelectDropdownListItemContentInfoText.module.css'

function LabelSelectDropdownListItemContentInfoText({ ref, value }) {
  const { label } = value

  return label ? (
    <Text
      className={styles.labelListItemContentInfoText}
      ref={ref}
      style={{
        backgroundColor: getLabelColor(value),
        color: LABEL_TEXT_COLOR,
      }}
    >
      {label}
    </Text>
  ) : null
}

export default LabelSelectDropdownListItemContentInfoText
